<template>
  <div @click="$router.push({ path: '/work/details/' + link, params: {link, title, src, year }})" ref="bg" class="bg">
    <img class="img" :src="require('../../img/work/' + src)" />
    <div class="overlay-t"></div>
    <div class="title2">{{title}}<br><b>{{year}}</b></div>
  </div>
</template>
<script>
export default {
  name: "tile",
  data() {
    return {
      isLoading: true
    };
  },
  props: ["src", "title","year","link"],
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  },
  methods: {}
};
</script>
<style>
.overlay-t{
    background:#000;
    opacity: 0;
    transition:all .3s ease;
    position: absolute;
    width:100%;
    height:100%;
    z-index: 10;
}
.img {
  width: 100%;
  position: absolute;
  z-index: 0;
  transform: scale(1,1);
  transition:all .3s ease;
}
.bg {
  overflow: hidden;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 300px;
  margin:5px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor:pointer;
  flex-basis: 32.1%;
  flex-grow: unset;
}
@media(min-width: 1200px){
  .bg:hover img{
    /* filter:blur(5px); */
}
.bg:hover .overlay-t{
    opacity: .5;
    
}
.bg:hover img{
    transform:scale(1.2,1.2);
}
.bg:hover .title2{
    transform:scale(1.2,1.2);
    letter-spacing: 10px;
}
.bg:hover .title2 b{
    opacity: 1;
    transform: translateY(0);
}
}
.title2 b {
    transition:all .3s ease;
    display: block;
    opacity: 0;
    transform: translateY(20px);
    letter-spacing: 0px;
    font-weight: 200;
    letter-spacing: 4px;
    font-size: .7em;
}
.title2 {
  transition:all .3s ease;
  text-align: center;
  color: #fff;
  z-index: 100;
  font-size: 20pt;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-weight: 200;
}
@media(max-width:728px){
  .img {
    height:100%;
    width:unset;
  }
  .bg{
    flex-basis: 100%;
    
    height:400px;
  }

}
</style>